/* eslint-disable no-useless-catch */
import Service from "../../service";

const ReportingService = {
  getList: async (token, currentPage = 1, items_per_page = 10, body = null) => {
    try {
      return await Service.post({
        url: `/accounts/filter/list?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getFinancialList: async (token, body = null) => {
    try {
      return await Service.post({
        url: `/accounts/filter/list?current_page=${1}&items_per_page=${10}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getReportByFilter: async (token, body = null) => {
    try {
      return await Service.post({
        url: `/finance/v1/transaction/report`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  duplicate: async (token, body) => {
    try {
      return await Service.post({
        url: `/accounts/filter/duplicate`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  addPublic: async (token, body) => {
    try {
      return await Service.update({
        url: `/accounts/filter/public`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  addFavourite: async (token, body) => {
    try {
      return await Service.update({
        url: `/accounts/filter/favourite`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteFilter: async (token, body) => {
    try {
      return await Service.remove({
        url: `/accounts/filter`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
};

export default ReportingService;
